import { fetchActivationCount } from "@/utils/activationEmployeeCount";

/**
 * ER-11818 — shared activate/reactivate employee-count confirmation for the catalog
 * surfaces (Options API). Responsibility Canonical Rules 3.4 / 3.6 and Roles Rules
 * 3.4 / 3.6 require a preview of how many employees (N) will be assigned before a
 * Role or Responsibility is activated (DRAFT → ACTIVE) or reactivated (RETIRED →
 * ACTIVE).
 *
 * Consumers call `resolveActivationConfirmation(objectType, kind, id)`, which fetches N
 * and stores it on `activationEmployeeCount` (bound to the dialog's `employee-count`
 * prop). The caller then opens its confirmation dialog when N > 0 (or when N could not
 * be determined — `null`) and proceeds directly when N === 0.
 */
export default {
  data() {
    return {
      activationEmployeeCount: 0,
    };
  },
  methods: {
    /**
     * @param {"role"|"responsibility"} objectType
     * @param {"activate"|"reactivate"} kind
     * @param {number|string|null} id
     * @returns {Promise<number|null>} N, or null when the preview could not be determined.
     */
    async resolveActivationConfirmation(objectType, kind, id) {
      const accountId = this.accountId || JSON.parse(localStorage.getItem("currentAccountID"));
      const count = await fetchActivationCount(objectType, kind, accountId, id);
      this.activationEmployeeCount = count ?? 0;
      return count;
    },
  },
};
